import { gql } from '@apollo/client';
import config from '../../config';
import { Base64 } from 'utils/encoding';

const styleIndex = config.algolia.algolia_prefix + 'styles';
const itemIndex = config.algolia.algolia_prefix + 'items';

const DATA_MAPPING = [
    {
        name: 'styleData',
        indexes: styleIndex,
        getIds: '(r) => [r?.doc?.style?.id]',
        skip: '(r) => !r?.doc?.style?.id',
    },
    {
        name: 'itemData',
        indexes: itemIndex,
        getIds: '(r) => [r?.doc?.item?.id]',
        skip: '(r) => !r?.doc?.item?.id',
    },
    {
        name: 'styleContext',
        indexes: styleIndex,
        getIds: '(r) => [r?.context?.style?.id]',
        skip: '(r) => !r?.context?.style?.id',
    },
];

export const SEARCH_WARDROBE = gql`
    query LocationsQuery ($__typename : String!, $index : String!, $query : String!, $filters: String!, $hit : Number!, $page : Number!, $facets: [String]!, $restrictSearchableAttributes: [String]) {
        items @algolia(__typename: "algolia_items_created", index: $index, filters: $filters, hitsPerPage: $hit, query: $query, page: $page, facets: $facets, restrictSearchableAttributes: $restrictSearchableAttributes, populate: "${Base64.encode(
        JSON.stringify(DATA_MAPPING),
    )}") {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
